import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthProvider, { AuthContext } from '../../../contex/AuthProvider';

const PrivateRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <p className='text-primary'>Loading....</p>
    }
    if (user) {
        return children;
    }
    return <Navigate to='/login' state={{ from: location }} replace ></Navigate>
};

export default PrivateRoute;